import { render, staticRenderFns } from "./Counselling.vue?vue&type=template&id=7ca68790&scoped=true&"
import script from "./Counselling.vue?vue&type=script&lang=js&"
export * from "./Counselling.vue?vue&type=script&lang=js&"
import style0 from "./Counselling.vue?vue&type=style&index=0&id=7ca68790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca68790",
  null
  
)

export default component.exports